var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDeletar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 16,
    fill: "#E21F41"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.56 10.2716L17.2 10.9754H12.4C11.515 10.9754 10.8 11.6792 10.8 12.5504C10.8 13.4216 11.515 14.1254 12.4 14.1254H31.6C32.485 14.1254 33.2 13.4216 33.2 12.5504C33.2 11.6792 32.485 10.9754 31.6 10.9754H26.8L26.44 10.2716C26.17 9.73508 25.615 9.40039 25.01 9.40039H18.99C18.385 9.40039 17.83 9.73508 17.56 10.2716ZM31.6 15.7004H12.4L13.46 32.3855C13.54 33.6308 14.59 34.6004 15.855 34.6004H28.145C29.41 34.6004 30.46 33.6308 30.54 32.3855L31.6 15.7004Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeletar);
export default __webpack_public_path__ + "static/media/icon-deletar.2fce9f16793ec271db83477793c1912d.svg";
export { ForwardRef as ReactComponent };